{
  "tickets.nav": "Support",
  "tickets.title": "Support",
  "tickets.subtitle": "What clients asked. Work stays on the board.",
  "tickets.loadError": "We could not load tickets.",
  "tickets.notFound": "We could not find that ticket.",
  "tickets.empty.title": "No tickets here",
  "tickets.empty.open": "New client questions will land in this inbox.",
  "tickets.empty.unassigned": "Everything open already has someone on it.",
  "tickets.empty.mine": "Nothing is assigned to you right now.",
  "tickets.empty.resolved": "Resolved tickets will collect here.",
  "tickets.empty.thread.title": "Pick a ticket",
  "tickets.empty.thread.body": "Choose one from the list to read the conversation.",
  "tickets.filter.label": "Inbox",
  "tickets.filter.unassigned": "Unassigned",
  "tickets.filter.mine": "Mine",
  "tickets.filter.open": "Open",
  "tickets.filter.resolved": "Resolved",
  "tickets.status.open": "Open",
  "tickets.status.in_progress": "In progress",
  "tickets.status.resolved": "Resolved",
  "tickets.court.client": "Waiting on the client",
  "tickets.court.staff": "Waiting on you",
  "tickets.unassigned": "Unassigned",
  "tickets.reply": "Reply",
  "tickets.reply.placeholder": "Write a reply the client will see.",
  "tickets.reply.send": "Send",
  "tickets.reply.sending": "Sending…",
  "tickets.claim": "Claim",
  "tickets.claiming": "Claiming…",
  "tickets.resolve": "Resolve",
  "tickets.resolve.confirmTitle": "Resolve this ticket?",
  "tickets.resolve.confirmBody": "The client will see it as resolved. They can still reply, which reopens it.",
  "tickets.resolve.confirm": "Resolve ticket",
  "tickets.resolve.pending": "Resolving…",
  "tickets.reopen": "Reopen",
  "tickets.convert": "Convert to task",
  "tickets.convert.title": "Turn this into internal work",
  "tickets.convert.body": "Creates a task on the board. The client still only sees this ticket.",
  "tickets.convert.project": "Project",
  "tickets.convert.projectHint": "Required. Pick one of this client's projects.",
  "tickets.convert.noProjects": "This client has no project yet. Open one before converting.",
  "tickets.convert.confirm": "Create task",
  "tickets.convert.pending": "Creating…",
  "tickets.convert.done": "Task {reference} is on the board.",
  "tickets.closeSuggested": "The linked task is finished. Close this ticket?",
  "tickets.closeSuggested.task": "Task {reference}",
  "tickets.fromTicket": "From {number}",
  "tickets.reassign": "Reassign",
  "tickets.reassign.title": "Hand this to someone else",
  "tickets.reassign.body": "The ticket keeps an owner. Pick a teammate who can see tickets.",
  "tickets.reassign.search": "Search the team",
  "tickets.reassign.confirm": "Reassign",
  "tickets.versionConflict": "Someone else changed this ticket. Reload and try again.",
  "tickets.home.title": "Client support",
  "tickets.home.open": "Open",
  "tickets.home.unassigned": "Unassigned",
  "tickets.home.inProgress": "In progress",
  "tickets.home.caption": "Not counted as task throughput.",
  "portal.tickets.nav": "Support",
  "portal.tickets.title": "Your support",
  "portal.tickets.subtitle": "Questions and requests for 404 Creative.",
  "portal.tickets.new": "New request",
  "portal.tickets.empty.title": "No requests yet",
  "portal.tickets.empty.body": "Send a question and the team will answer here.",
  "portal.tickets.loadError": "We could not load your tickets.",
  "portal.tickets.compose.title": "New request",
  "portal.tickets.compose.subtitle": "The team will see this and reply on this page.",
  "portal.tickets.field.title": "Subject",
  "portal.tickets.field.body": "Your message",
  "portal.tickets.field.project": "Project",
  "portal.tickets.field.projectNone": "No specific project",
  "portal.tickets.submit": "Send request",
  "portal.tickets.submitting": "Sending…",
  "portal.tickets.back": "All support",
  "portal.tickets.reply": "Reply",
  "portal.tickets.reply.placeholder": "Write a follow-up.",
  "portal.tickets.reply.send": "Send",
  "portal.tickets.reply.sending": "Sending…",
  "portal.tickets.compose.error": "We could not send the ticket. Try again.",
  "portal.tickets.homeTile": "Open support",
  "portal.tickets.notFound": "We could not find that ticket.",
  "notifications.sentence.ticketOpened": "{actor} opened ticket {target}",
  "notifications.sentence.ticketReplied": "{actor} replied on {target}"
}
